import type { Project } from "@vibe/shared";

export function ProjectSymbol({
  project,
  className = "project-symbol",
  logo = project.logo,
}: {
  project: Project;
  className?: string;
  logo?: string | null;
}) {
  return (
    <span
      className={className}
      style={{ color: project.color, background: `${project.color}20` }}
      aria-hidden="true"
    >
      {logo ? (
        <img
          src={`/api/v1/projects/${project.id}/logo?v=${encodeURIComponent(logo)}`}
          alt=""
        />
      ) : (
        project.name.slice(0, 1).toUpperCase()
      )}
    </span>
  );
}
